// Supporting Documents runs the same export as Download All and downloads its ZIP without the
// responses file, so the ZIP holds only the files attached to the VQQ.
export const SUPPORTING_DOCUMENTS_FILE_TYPE = "rfisupportingdocs";

const SUPPORTING_DOCUMENTS_LABEL = "Supporting Documents";
const RESPONSES_LABEL = /\s(?:Partial\s)?Responses$/;

// The ZIP is named after the export's file, with Supporting Documents in place of its label:
// "PPD - Bioanalytical - OCT 9, 2026 - Malvern, Pennsylvania Responses"
//   -> "PPD - Bioanalytical - OCT 9, 2026 - Malvern, Pennsylvania Supporting Documents"
export const supportingDocumentsZipName = (responsesFileName) => {
  const base = (responsesFileName || "").trim().replace(RESPONSES_LABEL, "");
  return base ? `${base} ${SUPPORTING_DOCUMENTS_LABEL}` : SUPPORTING_DOCUMENTS_LABEL;
};

// The name a finished export is announced and saved under.
export const exportDownloadName = (fileType, effectiveName) =>
  fileType === SUPPORTING_DOCUMENTS_FILE_TYPE
    ? supportingDocumentsZipName(effectiveName)
    : effectiveName;

// The supporting-document count is only asked for when the menu would offer Supporting Documents.
export const shouldCountSupportingDocuments = (exportState) =>
  Boolean(exportState?.canExport && exportState?.options?.includes("SUPPORTING_DOCS"));

// Supporting Documents is offered only when an export of the VQQ would include files. Until the
// count is known, or when it could not be read, the option stays hidden rather than producing an
// empty ZIP.
export const withSupportingDocumentsAvailability = (options, supportingDocumentCount) =>
  supportingDocumentCount > 0
    ? options
    : (options || []).filter((option) => option !== "SUPPORTING_DOCS");
